import styled from "styled-components";
import { colors, device } from "../../components/utils";

const Wrapper
	= styled.div`
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		.logo {
			width: calc(60px + 4vw);
		}

		.title {
			font-size: 160%;
			font-weight: 600;
			margin-top: calc(4px + .4vw);
		}

		.desc {
			text-align: center;
			color: ${colors.text.secondary};
			margin-top: calc(8px + .4vw);
			margin-bottom: calc(20px + 1vw);
		}

		.content {
			width: 100%;
		}
	`

export default Wrapper
